import type { PaletteMaterialSlot } from "building-types/materials/paletteMaterialSlotTypes";
import type { PolyLine2, PolyLine2Polygon } from "geom/polyLine2Types";
import type { PolyLineEdgeType } from "geom/polyLineTypes";

export enum OpeningTrimTypes {
  HEAD_CASING = "HEAD_CASING",
  SIDE_CASING = "SIDE_CASING",
  APRON = "APRON",
  STOOL = "STOOL",
  KEYSTONE = "KEYSTONE",
}
export type OpeningTrimType = keyof typeof OpeningTrimTypes;

export interface OpeningTrimBase<T extends OpeningTrimType> {
  readonly id: string;
  readonly type: T;
  readonly name: string;
  readonly rail?: PolyLine2;
  readonly elevationProfile?: PolyLine2Polygon;
  readonly elevationProfileEdgeTypes?: readonly (readonly PolyLineEdgeType[])[];
  readonly width?: number;
  readonly depth?: number;
  readonly profileId?: string;
  readonly materialId?: PaletteMaterialSlot;
}

export type OpeningTrim = OpeningTrimBase<OpeningTrimType>;

export type OpeningTrimOpeningType = "WINDOW" | "DOOR";
